import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import styles from "./PaymentSuccess.module.css";

export default function PaymentSuccess() {
  const { userData } = useContext(UserContext);
  const [timeoutReached, setTimeoutReached] = useState(false);

  useEffect(() => {
    if (!userData) {
      window.location.replace("/login");
    }
  }, [userData]);

  // Timeout de segurança (15s)
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeoutReached(true);
    }, 15000);

    return () => clearTimeout(timer);
  }, []);

  // Observa liberação de acesso
  useEffect(() => {
    if (userData?.userType?.premiumReport) {
      window.location.replace("/profile");
    }
  }, [userData]);

  if (userData?.userType?.premiumReport) {
    return (
      <div className={styles.card}>
        <div className={styles.icon}>✓</div>
        <h1>Acesso liberado</h1>
        <p>Seu pagamento foi confirmado com sucesso.</p>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {!timeoutReached && !userData?.userType?.premiumReport && (
          <>
            <div className={styles.iconPending}>⏳</div>
            <h1>Estamos finalizando seu acesso</h1>

            <p className={styles.primary}>
              Se você acabou de concluir um pagamento, estamos confirmando as
              informações agora.
            </p>

            <p className={styles.secondary}>Isso pode levar alguns segundos.</p>

            <div className={styles.loader} />
          </>
        )}
      </div>
    </div>
  );
}
